import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';

import { formatDate } from 'src/utils/format-date';
import { getStorage } from 'src/utils/local-storage-versioning';
import { Room } from 'src/shared/types/room';
import { UserChoices } from 'src/shared/types/user-choices';

import { styles } from './styles';

export type BookingDetailsProps = {
    roomData: Room;
    userChoices: UserChoices;
};

export const BookingDetailsContent: FC<BookingDetailsProps> = ({ roomData, userChoices }) => {
    const { t } = useTranslation();
    const storage = getStorage();
    const { paymentPlanId = null } = storage.redirectState;

    if (!userChoices.term || !userChoices.instalmentType || !userChoices.numberOfStudents)
        return null;

    const count = userChoices.term.duration;
    const bookingSummaryKey =
        roomData.monthly_price && !paymentPlanId
            ? 'booking_summary_months_count'
            : 'booking_summary_weeks_count';

    return (
        <Box css={styles.detailsWrapper}>
            {[
                {
                    header: t('your_details_booking_length'),
                    content: t(bookingSummaryKey, {
                        count,
                    }),
                },
                {
                    header: t('your_details_booking_start_date'),
                    content: formatDate(userChoices.term.startDate),
                },
                {
                    header: t('your_details_booking_end_date'),
                    content: formatDate(userChoices.term.endDate),
                },
                {
                    header: t('your_details_booking_students_count'),
                    content: `${i18next.t('your_details_student_count', { count: userChoices.numberOfStudents })}`,
                },
                {
                    header: t('your_details_booking_instalment_plan'),
                    content: userChoices.instalmentType,
                },
            ].map((item) => (
                <Box key={item.header} css={styles.subContainer}>
                    <Typography variant="h4" css={styles.subContainerHeader}>
                        {item.header}
                    </Typography>
                    <Typography variant="h4" css={styles.subContainerContent}>
                        {item.content}
                    </Typography>
                </Box>
            ))}
        </Box>
    );
};
